import { handlerRespAxiosMonitorLogin  } from "../../../../utils/handleResponse";

const actions = {
  setName({ commit }, value) {
    commit("SET_NAME", value);
  },
  setToken({ commit }, value) {
    commit("SET_TOKEN", value);
  },
  setRefresh({ commit }, value) {
    commit("SET_REFRESH", value);
  },
  setObjUsuario({ commit }, obj) {
    commit("SET_OBJ_USUARIO", obj);
  },
  async SESSION_LOGOUT(_) {
    try {
      return await handlerRespAxiosMonitorLogin("post", "session/logout");
    } catch (error) {
      console.log("[Error] in function: SESSION_LOGOUT", error);
      throw error;
    }
  },
  async SESSION_UPDATE(_) {
    try {
      return await handlerRespAxiosMonitorLogin("post", "session/update");
    } catch (error) {
      console.log("[Error] in function: SESSION_UPDATE", error);
      throw error;
    }
  },
  async RENEW_TOKEN(_, { refreshToken }) {
    try {
      return await handlerRespAxiosMonitorLogin(
        "post",
        "security/renew-token",
        { refreshToken }
      );
    } catch (error) {
      console.log("[Error] in function: RENEW_TOKEN", error);
      throw error;
    }
  },
}
export default actions;